import { render, staticRenderFns } from "./SearchSeafarer.vue?vue&type=template&id=2df7851f"
import script from "./SearchSeafarer.vue?vue&type=script&lang=ts"
export * from "./SearchSeafarer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports